import { UserType } from '@nemuru-eng/js-api-client';

import { LenderRequestIdLink } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/CheckoutSessionLinks/components/LenderRequestIdLink';
import { PaymentIntentLink } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/CheckoutSessionLinks/components/PaymentIntentLink';
import { PaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/PaymentMethodDetail/PaymentMethodDetailEntity';
import { AbstractLoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/entities/PaymentMethodDetail/AbstractLoanPaymentMethodDetailEntity';
import { CustomDivider } from '@/components/shared/components/CustomDivider';

interface CheckoutSessionLinksProps {
  paymentMethodDetailEntity: PaymentMethodDetailEntity;
  userType: UserType;
}

export const CheckoutSessionLinks = ({ paymentMethodDetailEntity, userType }: CheckoutSessionLinksProps) => {
  const paymentMethodId = paymentMethodDetailEntity.paymentMethodId;
  const paymentMethodUrl = paymentMethodDetailEntity.paymentMethodUrl();
  const showPaymentIntent =
    paymentMethodId && paymentMethodUrl && [UserType.ADMIN, UserType.SUPER_ADMIN].includes(userType);

  const showLenderRequestId =
    paymentMethodDetailEntity instanceof AbstractLoanPaymentMethodDetailEntity &&
    paymentMethodDetailEntity.lenderRequestId &&
    paymentMethodDetailEntity.selectedProvider;

  if (!showLenderRequestId && !showPaymentIntent) {
    return null;
  }

  return (
    <>
      <CustomDivider />
      {showLenderRequestId && <LenderRequestIdLinkWrapper paymentMethodDetailEntity={paymentMethodDetailEntity} />}
      {showPaymentIntent && <PaymentIntentLink paymentMethodId={paymentMethodId} paymentMethodUrl={paymentMethodUrl} />}
    </>
  );
};

const LenderRequestIdLinkWrapper = ({
  paymentMethodDetailEntity,
}: {
  paymentMethodDetailEntity: AbstractLoanPaymentMethodDetailEntity;
}) => {
  const lenderName = paymentMethodDetailEntity.selectedProvider;
  const lenderRequestId = paymentMethodDetailEntity.lenderRequestId;
  const showLenderRequestId = lenderRequestId && lenderName;

  if (!showLenderRequestId) {
    return null;
  }

  return <LenderRequestIdLink lenderRequestId={lenderRequestId} lenderName={lenderName} />;
};
